var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('p',{staticClass:"instruction"},[_vm._v("Pick a color")]),_c('Palette',{on:{"color":function($event){_vm.penColor = $event}}}),_c('p',{staticClass:"instruction"},[_vm._v("Click a pixel to change its color")]),_c('Canvas',{attrs:{"penColor":_vm.penColor}}),_c('About')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }